import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { CustomersModel } from 'src/app/models/customers-model';
import { CustomersService } from 'src/app/services/customers.service';

@Component({
  selector: 'app-customers-search',
  templateUrl: './customers-search.component.html',
  styleUrls: ['./customers-search.component.css']
})
export class CustomersSearchComponent implements OnInit {
 //------------------- patient decliration ------------------------
  patientCode = '';
  patientFName = '';
  diagnosis = '';
  patientLName = '';
  patientFullName = '';
  birthDate = '2022-01-01';
  education = '';
  nationality = '';
  occupation = '';
  referredFrom = '';
  telHome = '';
  telBusin = '';
  telMobile = '';
  addressHome = '';
  addressBusin = '';
  email = '';
  relativeName = '';
  relativeTelHome = '';
  relativeTelBusin = '';
  relativeTelMobile = '';
  relativeAddressHome = '';
  relativeAddressBusin = '';
  userDef1 = '';
  userDef2 = '';
  userDefDate = '';
  userDefNum = '';
  dateEntry = '';
  gender = '';
  marital = '';
  noChildren = '';
  ageOldest = '';
  ageYoungest = '';
  status = '';
  cancerID = '';
  docCode = '';
  txtRef = '';
  pathology = '';
  menstrual = '';
  since = '';
  contraception = '';
  pregnancy = '';
  smoker = '';
  smokerType = '';
  noPacks = '';
  sSince = 0;
  mSince = '';
  drinkingAlcohol = '';
  deteRelapse = '';
  gov='';
  compCode = '10';
  userID = '';
  ageYear=0;
  modifiedDate = '';
    CustomerList: CustomersModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();
  constructor(public CustomersService: CustomersService, public customer: CustomersModel,
      public dialogRef: MatDialogRef<CustomersSearchComponent>,
      public storage: LocalStorageService,
      @Inject(MAT_DIALOG_DATA)
      public patientSelectedData: CustomersModel) { }

  ngOnInit(): void {
    this.retrivePatientsTop();
  }

retrivePatients() {
    this.CustomerList = [];
    this.CustomersService.getPatientLookup(this.patientCode, this.patientFName,this.telMobile,this.telHome,this.telBusin,this.cancerID, this.compCode).subscribe((data: CustomersModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.CustomerList[i] = data[i];
      }
      console.log(data);
    })
  }
  retrivePatientsTop() {
    debugger;
    this.CustomersService.GetCustomersTop(this.storage.retrieve(('stgCompCode'))).subscribe((data: CustomersModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.CustomerList[i] = data[i];
      }
      console.log(data);
    })
  }
  clickSelect(){
    this.storage.store('stgSearchCode', this.patientCode);
  }
  SelectPatient(Customers: CustomersModel){

    this.patientSelectedData.patientCode = Customers.patientCode
    this.patientSelectedData.patientFName = Customers.patientFName
    this.patientSelectedData.birthDate= Customers.birthDate
    this.patientSelectedData.diagnosis= Customers.diagnosis
    this.patientSelectedData.gender= Customers.gender
    this.patientSelectedData.telMobile= Customers.telMobile
    this.patientSelectedData.status= Customers.status
    this.patientSelectedData.pathology= Customers.pathology
    this.patientSelectedData.cancerID= Customers.cancerID
    this.patientSelectedData.dateEntry= Customers.dateEntry
    this.patientSelectedData.modifiedDate = Customers.modifiedDate
    this.patientSelectedData.pathology = Customers.pathology
    this.patientSelectedData.ageYear = Customers.ageYear
    this.patientSelectedData.cancerID = Customers.cancerID
    this.patientSelectedData.addressHome = Customers.addressHome
    this.patientSelectedData.docCode = Customers.docCode
    this.patientSelectedData.marital = Customers.marital
    this.patientSelectedData.pathology = Customers.pathology
    this.patientSelectedData.email = Customers.email
    this.patientSelectedData.education = Customers.education
    this.patientSelectedData.occupation = Customers.occupation
    this.patientSelectedData.nationality = Customers.nationality
    this.patientSelectedData.gov = Customers.gov
    this.patientSelectedData.telHome = Customers.telHome
    this.patientSelectedData.status = Customers.status
    this.patientSelectedData.telBusin = Customers.telBusin


    this.patientSelectedData.userID = LocalStorage.name
    this.patientSelectedData.dateEntry = Customers.dateEntry
    this.patientSelectedData.modifiedDate = Customers.modifiedDate
    this.patientSelectedData.compCode = Customers.compCode
    this.submitClicked.emit(this.patientSelectedData);
    this.dialogRef.close();

  }



}
